<template>
    <div class="navmb">
        <div class="flex flexa">
            <el-icon :size="20" color="#337EFF" class="icon astyle" @click="$router.back()">
                <Back />
            </el-icon>
            <span class="">{{ state.vtitle || '知识库文档搜索' }}</span>
        </div>
    </div>
    <div v-loading="vselect.docCategoryId.loading">
        <div class="typeL">
            <template v-for="(item, index) in typeL" :key="'categoryTitle'+index">
                <p class="typeL_line" v-if="index * 1 + 1 == typeL.length&&typeL.length>1">/</p>
                <p :class="index != 0 ? 'typeL_titles' : 'typeL_title'">{{ item.categoryTitle }}</p>
            </template>
        </div>
        <div class="background" v-if="typeL.length > 0">
            <p class="background_title">{{ typeL[0].categoryTitle }}</p>
            <p class="background_content">{{ typeL[0].categoryContent }}</p>
            <img class="background_img"
                src="https://bucket-mvs.oss-cn-beijing.aliyuncs.com/1745570232%E7%BC%96%E7%BB%84%2015%E5%A4%87%E4%BB%BD%204.png"
                alt="">
        </div>
        <el-tabs class="mart40" v-if="typeL.length > 0" v-model="search_form.twoCategoryId" @tab-change="queryList">
            <el-tab-pane v-for="(item, index) in typeL[0].list" :key="'tabs' + index" :label="item.categoryTitle"
                :name="item.id"></el-tab-pane>
        </el-tabs>
        <p class="h20"></p>
        <div class="m-resultl">
            <ul class="ul-listl3" v-if="act == 1">
                <li v-for="(item, index) in list" :key="index">
                    <router-link :to="`/knowledgeInfo/${item.id}`" class="con">
                        <div class="tit">
                            <div v-html="item.docTitle"></div>{{ item.docNumber ? `(${item.docNumber})` : '' }}
                        </div>
                        <div class="desc" v-html="item.docContent"></div>
                        <div class="stips">所属分类：{{ item.categoryName }}</div>
                    </router-link>
                </li>
            </ul>
            <div class="m-pages">
                <div class="pages">
                    <el-pagination v-model:currentPage="search.pageNumber" @update:page-size="getDocList()"
                        @update:current-page="getDocList" :page-sizes="[10, 20, 30, 50]"
                        layout=" prev, pager, next, sizes, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//图标
import { mapGetters } from 'vuex';
import { Back } from '@element-plus/icons-vue'
import { debounce, throttle } from 'throttle-debounce'
export default {
    setup() {
        return {
            state: history.state
        }
    },
    components: {
        Back
    },
    computed: {
        ...mapGetters({
            searchList: 'searchStore/get_search',
        }),
    },
    data() {
        return {
            typeL: [],
            act: 1,
            loading: false,
            search_form: {
                categoryId: '',
                docType: '',
                docTitle: '',
            },
            search: {
                categoryId: '',
                docType: '',
                docTitle: '',
                pageNumber: 1,
                pageSize: 10
            },
            list: [],
            total: 0,
            vselect: {
                docCategoryId: {
                    props: {
                        checkStrictly: false,
                        emitPath: false,
                        multiple: true,
                        value: 'id',
                        label: 'categoryTitle',
                        children: 'list'
                    },
                    loading: false,
                    options: []
                }
            },
        };
    },
    mounted() {
        this.vselect_docCategoryId()
    },
    methods: {
        async vselect_docCategoryId() {
            try {
                this.vselect.docCategoryId.loading = true
                const { records, total } = await this.$api.know.docCateList({
                    pageNumber: 1,
                    pageSize: 1000
                })
                console.log(records, '**********----------**********', this.search_form)
                this.typeL = []
                records.map(a => {
                    if (a.id == this.search_form.twoCategoryId) { this.typeL.push(a) }
                    a.list.map(b => {
                        if (b.id == this.search_form.twoCategoryId) {
                            this.typeL.push(a)
                            this.typeL.push(b)
                        }
                    })
                })
                console.log('******************************************', this.typeL)
                this.vselect.docCategoryId.options = records
                this.vselect.docCategoryId.loading = false
            } catch (e) {
                this.vselect.docCategoryId.loading = false
                this.vselect.docCategoryId.options = []
            }
        },
        queryList: throttle(300, function () {
            this.search.categoryId = this.search_form.categoryId ? this.search_form.categoryId.join(',') : ''
            this.search.docType = this.search_form.docType;
            this.search.docTitle = this.search_form.docTitle;
            this.search.twoCategoryId = this.search_form.twoCategoryId;
            this.$store.commit('searchStore/putSearch', this.search_form.docTitle)
            this.getDocList(1)
        }),
        async getDocList(pageNumber) {
            try {
                pageNumber && (this.search.pageNumber = pageNumber)
                this.loading = true
                let param = JSON.parse(JSON.stringify(this.search))
                let docTitle = param.docTitle||''
                delete param.docTitle
                const { records, total } = await this.$api.know.getDocLists(param,{docTitle})
                console.log('recordsrecordsrecords', records)
                this.list = records
                this.total = total
            } catch (e) {
                return console.log(e)
            } finally {
                this.loading = false
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            const state = history.state
            console.log('statestatestatestate', state)
            vm.search.categoryId = state.categoryId ? state.categoryId.split(',') : ''
            vm.search.docType = state.docType
            vm.search.docTitle = state.docTitle
            vm.search_form.categoryId = state.categoryId ? state.categoryId.split(',') : ''
            vm.search_form.docType = state.docType
            vm.search_form.docTitle = state.docTitle
            vm.search_form.twoCategoryId = state.twoCategoryId
            vm.queryList()
        })
    }
};
</script>

<style lang="scss" scoped>
body {
    background-color: #fff
}

.typeL {
    display: flex;
    width: 100%;

    .typeL_line {
        display: inline-block;
        color: #999999;
        font-size: 14px;
        line-height: 60px;
        margin: 0 10px;
    }

    .typeL_title {
        display: inline-block;
        color: #999999;
        font-size: 14px;
        line-height: 60px;
        cursor: pointer;
    }

    .typeL_titles {
        display: inline-block;
        color: #333333;
        font-size: 14px;
        line-height: 60px;
        cursor: pointer;
    }
}

.background {
    width: 100%;
    position: relative;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 50px 60px;
    box-sizing: border-box;
    overflow: hidden;

    .background_title {
        display: inline-block;
        font-size: 24px;
        color: #333333;
        width: 100%;
        z-index: 2;
    }

    .background_content {
        display: inline-block;
        max-width: 600px;
        line-height: 20px;
        color: #666666;
        margin-top: 16px;
        z-index: 2;
    }

    .background_img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
}

























.navmb {
    .icon {
        margin-right: 10px;
    }
}

.m-searchl {
    overflow: hidden;

    // background: #fff;
    // padding: 20px;
    .search {
        overflow: hidden;
        // margin-bottom: 20px;
        margin-bottom: 20px;
    }

    .history {
        overflow: hidden;

        .ll {
            float: left;
            font-size: 12px;
            color: #999999;
            line-height: 30px;
            margin-right: 14px;
        }

        .rr {
            overflow: hidden;

            span {
                display: block;
                float: left;
                min-width: 82px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 12px;
                color: #666666;
                margin-right: 16px;
                padding: 0 15px;
            }
        }
    }
}

.m-resultl {
    overflow: hidden;
    background-color: #fff;
    padding: 20px 30px;
}



.ul-listl3 {
    overflow: hidden;
    margin-bottom: 54px;

    .con {
        display: block;
        overflow: hidden;
        padding: 29px 0 30px;
        border-bottom: 1px dashed #E6E6E6;

        .tit {
            font-size: 18px;
            line-height: 1.333em;
            color: #151822;
            margin-bottom: 14px;
            transition: .5s;

            span {
                color: #337EFF;
            }
        }

        .desc {
            font-size: 14px;
            color: #686868;
            line-height: 2em;
            overflow: hidden;
            margin-bottom: 6px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            /* 确保文本正常换行 */
        }

        .stips {
            font-size: 12px;
            line-height: 2.333em;
            overflow: hidden;
            color: #9c9c9c;
        }
    }

    .con:hover {
        .tit {
            color: #337EFF;
        }
    }
}

.m-pages {
    overflow: hidden;
    text-align: center;
    font-size: 0;

    .pages {
        display: inline-block;
        vertical-align: middle;
    }
}
</style>